<template>
  <div>
    <div class="container" :style="backgroundImage">
      <!-- 登录框 -->
      <el-card class="box-card">
        <!-- <div class="title">团油商户端管理系统</div> -->
        <div class="check-box">
          <div class="account-title-wrap" :class="{right: index === 1}" v-for="(item,index) in titleArr" :key="index" @click="switchLogin(index)">
            <div class="account-title-text" :class="{check:currentIndex === index, borderRight: index !== titleArr.length - 1}">
              <span>{{item}}</span>
            </div>
          </div>
        </div>
        <!-- 账号登陆 -->
        <el-form :model="loginOptions" ref="accountForm" :rules="accountRules" class="form" v-if="loginType === 0">
          <el-form-item  prop="account">
            <el-input v-model.trim="loginOptions.account"  @focus="$track.clickEvent('输入账号', 1636083550)" autocomplete="off" placeholder="请输入账号" maxlength="50"></el-input>
          </el-form-item>
          <el-form-item  prop="password" class="item">
            <el-input type="password" v-model.trim="loginOptions.password" @focus="$track.clickEvent('输入密码', 1636083551)" maxlength="30" placeholder="请输入密码"></el-input>
          </el-form-item>
          <el-form-item :class="['check-item', platformClass]">
            <el-checkbox v-model="loginOptions.isCheckByAccount"><span class="auto">自动登录</span></el-checkbox>
          </el-form-item>
          <el-form-item class="check-item" v-if="isDefaultLogin">
            <!-- <el-checkbox v-model="loginOptions.check" @change="agreementChange"></el-checkbox> -->
            <span style="margin-left:4px">我已阅读并同意 <span class="agreement" @click="agreement(1)">《平台服务协议》</span>和 <span class="agreement" @click="agreement(2)">《商户隐私政策》</span></span>
          </el-form-item>
          <el-form-item :class="['btn-item', platformClass]">
            <el-button type="primary" @click="toLogin('accountForm')">登录</el-button>
          </el-form-item>
        </el-form>
        <!-- 手机登陆 -->
        <el-form :model="phoneOptions" ref="phoneForm" class="form" :rules="rules" v-else>
          <el-form-item  prop="mobile">
            <el-input type="tel"  v-model.trim="phoneOptions.mobile" autocomplete="off" placeholder="请输入手机号" maxlength="11" readonly @focus="removeAttr"></el-input>
          </el-form-item>
          <el-form-item  prop="verificationCode" :class="['item', platformClass]">
            <el-input type="text" style="width: 59%;margin-right: 12px" v-model.trim="phoneOptions.verificationCode"  maxlength="6" autocomplete="off" placeholder="请输入验证码" readonly @focus="removeAttr"></el-input>
            <el-button @click="toSendCode" type="primary" :disabled="isSending" class="btn" :style="{width: '36%', height: '40px', padding: paddingType[0], backgroundColor: paddingType[1],borderRadius: '2px',borderColor: paddingType[2], color: paddingType[2]} " ><span style="font-size: 12px">{{codeText}}</span></el-button>
          </el-form-item>
          <el-form-item :class="['check-item', platformClass]">
            <el-checkbox v-model="phoneOptions.isCheck"><span class="auto">自动登录</span></el-checkbox>
          </el-form-item>
          <el-form-item class="check-item" v-if="isDefaultLogin">
            <!-- <el-checkbox v-model="phoneOptions.check" @change="agreementChange"></el-checkbox> -->
            <span style="margin-left:4px">我已阅读并同意 <span class="agreement" @click="agreement(1)">《平台服务协议》</span>和 <span class="agreement" @click="agreement(2)">《商户隐私政策》</span></span>
          </el-form-item>
          <el-form-item :class="['btn-item', platformClass]">
            <el-button type="primary" @click="toLogin('phoneForm')">登录</el-button>
          </el-form-item>
        </el-form>
      </el-card>
      <!-- 全局提示绑定手机号 -->
      <bind-phone :isLogin="true" ref="bindPhone" v-if="bindPhoneVisible" @close="close"></bind-phone>
      <!-- 协议弹窗 -->
      <Agreement ref="agreement" v-if="showAgreement" @closePop="closeAgree"></Agreement>
    </div>
    <!-- 下方链接 -->
    <about-link v-if="isDefaultLogin"></about-link>
  </div>
</template>
<script>
import { sendCode, loginByPhone, loginByAccount } from '@/api/login'
import { validPhone } from '@/utils/utils'
import MD5 from 'md5'
import aboutLink from './aboutLink'
import BindPhone from '@/views/account/components/BindPhone'
import Agreement from './components/agreement.vue'

let URL = require('url')
export default {
  name: 'login',
  components: {
    aboutLink,
    BindPhone,
    Agreement
  },
  data () {
    let checkFunc = (type) => {
      return (rule, value, callback) => {
        if (!value) {
          return callback(new Error(`请输入${type}`))
        } else {
          if (type === '手机号码' ? validPhone(value) : (value.length <= 30 && value.length >= 6)) {
            callback()
          } else {
            return callback(new Error(type === '手机号码' ? `${type}格式不正确` : `${type}为6-30字符`))
          }
        }
      }
    }
    let checkNoEmpyt = (type) => {
      return (rule, value, callback) => {
        if (!value) {
          return callback(new Error(`请输入${type}`))
        } else {
          callback()
        }
      }
    }
    return {
      bindPhoneVisible: false, // 全局手机号弹窗
      loginType: 0, // 0 账号/手机号登录  1 手机验证码登录
      currentIndex: 0,
      titleArr: ['账号密码登录','手机验证登录'],
      phoneOptions: {
        mobile: '', // 手机
        verificationCode: '', // 验证码
        isCheck: true, // 是否自动登录
        check: true
      },
      loginOptions: {
        account: '', // 账户
        password: '', // 密码
        isCheckByAccount: true,
        check: true
      },
      codeText: '获取验证码',
      rules: {
        mobile: [
          { validator: checkFunc('手机号码'), trigger: 'blur' }
        ],
        verificationCode: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ]
      },
      accountRules: {
        account: [
          { validator: checkNoEmpyt('账号'), trigger: 'blur' }
        ],
        password: [
          { validator: checkFunc('密码'), trigger: 'blur' }
        ]
      },
      isSending: false,
      token: null,
      showAgreement: false,
      agreeTimmer: null,
      agreeTimeNum: 0,
      isDefaultLogin: false, // 是否为普通登录
      isSdLogin: false, // 是否为顺达登陆
      isHBGSLogin: false, // 是否为河北高速
      backgroundImage: {'background-image': ''},
      bgImage: [
        { path: '/shundaLogin', url: 'https://web.nlktj.com/ty/merchant/image/logo/shunda_login_bg.png' },
        { path: '/hebeigaosuLogin', url: 'https://web.nlktj.com/ty/merchant/image/logo/hebeigaosu_login_bg.png' },
        { path: '/login', url: 'https://web.nlktj.com/ty/merchant/image/logo/login_back_img1.png' }
      ]
    }
  },
  created() {
    const backImage = (this.bgImage.find(i => window.location.pathname === i.path) || {}).url
    console.log('window.location.pathname', window.location.pathname)
    this.backgroundImage['background-image'] = `url(${backImage || 'https://web.nlktj.com/ty/merchant/image/logo/login_back_img1.png' })`

    this.isSdLogin = window.location.pathname === '/shundaLogin'
    this.isHBGSLogin = window.location.pathname === '/hebeigaosuLogin'
    this.isDefaultLogin = window.location.pathname === '/login'
    // this.backgroundImage['background-image'] = `url(${this.isSdLogin ? 'https://web.nlktj.com/ty/merchant/image/logo/shunda_login_bg.png' : 'https://web.nlktj.com/ty/merchant/image/logo/login_back_img1.png' })`
  },
  mounted () {
    this.init()
    const host = window.location.host
    if (host === 'gs.czb365.com') {
      window.location.href = 'https://gs.nlktj.com'
    }
    // 从url上获取token，用于判断是否是从宙斯跳转过来，如果存在token则自动登陆
    const token = URL.parse(location.href).query
    
    if (token) {
      this.token = token.split('=')[1]
      this.accountLogin()
    }
  },
  beforeDestroy () {
    clearInterval(this.agreeTimmer)
  },
  computed: {
    paddingType () {
      let {isSending, isHBGSLogin} = this
      console.log('isHBGSLogin', isHBGSLogin)
      const color = isHBGSLogin ? '#2D69FF' : '#E31937'
      if (isSending) {
        return ['0','#F4F4F5', color]
      } else {
        return ['0 10px 0 10px','transparent', color]
      }
    },
    platformClass () {
      return this.isHBGSLogin ? 'hbgs' : ''
    }
  },
  methods: {
    init () {
      this.phoneOptions = {
        mobile: '',
        verificationCode: '',
        isCheck: true,
        check: true
      }
      this.loginOptions = {
        account: '',
        password: '',
        isCheckByAccount: true,
        check: true
      }
    },
    clearValidate(formName) {
      this.$refs[formName].clearValidate() // 切换验证时清除验证
    },
    resetForm(formName) {
      this.$refs[formName].resetFields() // 重置表单
    },
    agreementChange(val) {
      if (val) this.$track.clickEvent('登录—勾选同意', 1637816085)
    },
    switchLogin (index) {
      this.currentIndex = index
      this.loginType = index
      if (!index) {
        this.$track.clickEvent('账号密码登录', 1636083549)
        this.resetForm('phoneForm')
        this.clearValidate('phoneForm')
      } else {
        this.$track.clickEvent('手机验证登录', 1636083552)
        this.resetForm('accountForm')
        this.clearValidate('accountForm')
      }
    },
    toLogin (formName) {
      const loginNumber = this.loginType === 0 && !this.loginOptions.check
      const loginPhone = this.loginType === 1 && !this.phoneOptions.check
      if ( loginNumber || loginPhone ) {
        this.$message.error('登录前，请阅读并勾选相关协议')
        return false
      }
      this.$track.clickEvent('登录', 1636083555)
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 将是否为顺达登陆保存在本地
          sessionStorage.setItem('isSdLogin', JSON.stringify(this.isSdLogin))
          this.$store.dispatch('permission/setPlatform', window.location.pathname)

          if (formName === 'phoneForm') {
            this.login()
          } else {
            this.accountLogin()
          }
        } else {
          return false
        }
      })
    },
    toSendCode () {
      this.$track.clickEvent('获取验证码', 1636083554)
      this.$refs.phoneForm.validateField('mobile', errMsg => {
        if (errMsg) {
          return false
        } else {
          this.sendCode()
        }
      })
    },
    // 打开协议
    agreement (type) {
      clearInterval(this.agreeTimmer)
      this.agreeTimeNum = 0
      this.agreeTimmer = setInterval(() => {
        this.agreeTimeNum++
      }, 1000)
      this.showAgreement = true
      this.$nextTick(() => {
        this.$refs.agreement.getContent(type)
      })
    },
    // 关闭协议
    closeAgree (data) {
      clearInterval(this.agreeTimmer)
      let obj = { tysj_trade_type: data.closeType, tysj_click_time: this.agreeTimeNum }
      let name = data.type === 1 ? '登录—平台服务协议' : '登录—商户隐私政策'
      let id = data.type === 1 ? '1637816086' : '1637816087'
      this.$track.clickEvent(name, id, obj)
      this.showAgreement = false
    },
    async sendCode () {
      let { phoneOptions: { mobile } } = this
      try {
        const { code } = await sendCode({ mobile })
        if (code !== 200) return
        this.isSending = true
        this.setCountText()
      } catch (error) {
        console.log(error.message)
      }
    },
    setCountText () {
      this.codeText = '60s后重新发送'
      let count = 60
      let timer = setInterval(() => {
        this.codeText = `${count}s后重新发送`
        if (count === 0) {
          clearInterval(timer)
          this.isSending = false
          this.codeText = '获取验证码'
        } else {
          count--
          this.codeText = `${count}s后重新发送`
        }
      }, 1000)
    },
    // 绑定手机号成功后子组件回调地址
    close () {
      this.bindPhoneVisible = false
      this.$router.push({ path: '/' })
    },
    async login () { // 手机号验证码登录
      let { isCheck, ...params } = { ...this.phoneOptions }
      try {
        const { code, result } = await loginByPhone({ ...params })
        if (code !== 200) return
        const { token, ...userInfo } = result
        // localStorage.setItem('loginInfo', JSON.stringify(result || {}))
        await this.$store.dispatch('user/setTokenAndUserInfo', { token: token, auto: isCheck, userInfo })
        // 是否展示绑定手机号全局弹窗 手机号未绑定 且 服务端开关打开
        if (userInfo.isGasMaster && !userInfo.mobile) {
          this.bindPhoneVisible = true
        } else {
          this.$router.push({ path: '/' })
        }
      } catch (error) {
        console.log(error.message)
      }
    },
    async accountLogin () { // 账号密码登录
      let { isCheckByAccount, ...params } = { ...this.loginOptions }
      params.password = MD5(params.password)
      // 如果存在token则使用token登陆
      if (this.token) params = { token: this.token }

      try {
        const { code, result } = await loginByAccount(params)
        if (code !== 200) {
          if (this.token) {
            this.$alert('自动登陆失败，请输入账号密码', '提示', {
              confirmButtonText: '确定',
              type: 'error',
              showClose: false,
              showCancelButton: false
            }).then(() => {
              this.token = null
              this.$router.replace({ path: '/login' })
            })
          }
          return
        }
        const { token, ...userInfo } = result
        // 登录成功埋点
        this.$track.anothorEvent('login', userInfo.userId)
        // localStorage.setItem('loginInfo', JSON.stringify(result || {}))
        await this.$store.dispatch('user/setTokenAndUserInfo', { token: token, auto: isCheckByAccount, userInfo })
        if (userInfo.isGasMaster && !userInfo.mobile) {
          this.bindPhoneVisible = true
        } else {
          this.$router.push({ path: '/' })
        }
      } catch (error) {
        console.log(error.message)
      }
    },
    removeAttr (e) {
      this.$track.clickEvent('输入手机号', 1636083553)
      e.target.removeAttribute('readonly')
    }
  }
}
</script>
<style lang="less" scoped>
  .container{
    width: 100%;
    min-width: 500px;
    height: 100vh;
    background-size: cover;
    background-repeat: no-repeat;
    position: relative;
    .login-logo {
      width: 550px;
      height: 200px;
      position: absolute;
      top: 130px;
      left: 160px;
      img {
        width: 250px;
      }
    }
    .box-card{
      position: absolute;
      background-color: #fff;
      width: 380px;
      height: 380px;
      top: 150px;
      right: 80px;
      padding: 48px;
      box-sizing: border-box;
      border-radius: 20px;
      .title{
        text-align: center;
        margin-bottom: 35px;
        font-size:16px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(34,34,34,1);
        line-height:18px
      }
      .check-box{
        display: flex;
        width: 100%;
        font-size:20px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:bold;
        .account-title-wrap{
          flex: 1;
          width: 50%;
          text-align: left;
          cursor: pointer;
          &.right{
            text-align: right;
          }
          .account-title-text{
            color: #666666;
            line-height:18px;
            font-weight:500;
            font-family:PingFangSC-Regular,PingFang SC;
            &.check{
              color:#222222;
              font-weight: bold;
            }
            &.borderRight {
              border-right: 1px solid #666666;
            }
          }
        }
      }
      .form{
        margin-top: 30px;
        .item{
          position: relative;
          margin-bottom: 0px;
          .btn{
            position: absolute;
            right: 0;
            bottom: 0;
          }
        }
        .check-item{
          margin-top: 10px;
          margin-bottom: 10px;
          .auto {
            font-size: 13px;
            color: #222222;
          }
          /deep/.el-form-item__content {
            line-height: 24px;
          }
          .agreement {
            color: #4B7EFE;
            cursor: pointer;
          }
        }
        .btn-item{
          /deep/.el-button {
            width: 100%;
            height: 50px;
            background-color: #E31937;
            border-radius: 8px;
            border: none;
            margin-top: 10px;
          }
        }
        .hbgs{
          /deep/.el-button {
            background-color: #2D69FF;
          }
          /deep/.el-checkbox__input.is-checked .el-checkbox__inner {
            background-color: #2D69FF;
            border-color: #2D69FF;
          }
        }
      }
    }
  }


/deep/.el-input__inner {
  display: inline-block;
	border-top-width: 1px;
	border-left-width: 1px;
	border-right-width: 1px;
  border-bottom-width: 1px;
  border-radius: 0;
  padding: 3;
  &::placeholder{
    font-size: 12px;
  }
	&::-webkit-input-placeholder{
    font-size: 12px;
  }
  &:-moz-placeholder{
    font-size: 12px;
  }
  &::-moz-placeholder{
    font-size: 12px;
  }
  &:-ms-input-placeholder{
    font-size: 12px;
  }
}

/deep/ .el-checkbox__inner {
  width: 10px;
  height: 10px;
  line-height: 15px;
  &::after{
    left: 3px;
    top: -1px;
  }
}
/deep/.el-checkbox__label{
  padding-left: 4px;
}
/deep/.el-card__body{
  padding: 0;
}
.check-item{
  /deep/.el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: #E31937;
    border-color: #E31937;
  }
}

</style>
